import { failure, inProgress, notAsked, RemoteData, success } from 'ngx-remotedata';
import { ErrorWrapper, SendBundleResponse } from '@trade-platform/ui-shared';
import { OrderSendBundleActions, OrderSendBundleActionTypes } from './actions';

export type OrderSendBundleState = RemoteData<SendBundleResponse, ErrorWrapper>;
const initialState = notAsked<SendBundleResponse, ErrorWrapper>();

export const orderSendBundleReducer = (
    state: OrderSendBundleState = initialState,
    action: OrderSendBundleActions
): OrderSendBundleState => {
    switch (action.type) {
        case OrderSendBundleActionTypes.ORDER_SEND_BUNDLE:
            return inProgress();
        case OrderSendBundleActionTypes.ORDER_SEND_BUNDLE_SUCCESS:
            return success(action.payload);
        case OrderSendBundleActionTypes.ORDER_SEND_BUNDLE_FAILURE:
            return failure(action.payload.error);
        case OrderSendBundleActionTypes.ORDER_SEND_BUNDLE_RESET:
            return notAsked();
        default:
            return state;
    }
};
